// src/PrivacyPolicy.jsx

import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-200 min-h-screen p-4 sm:p-8">
      <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 p-6 sm:p-10 rounded-lg shadow-lg">
        <h1 className="text-3xl sm:text-4xl font-bold mb-4 sm:mb-6 text-center text-[#1C74BB] dark:text-blue-400">
          Privacy Policy
        </h1>
        <p className="text-sm sm:text-base text-gray-500 dark:text-gray-400 text-center mb-8">
          Last Updated: January 03, 2025
        </p>

        <section className="mb-8">
          <p className="mb-4 text-base sm:text-lg">
            Welcome to <span className="font-semibold text-[#1C74BB] dark:text-blue-400">Dynamic Softlink</span>. Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal data when you use our website, products, or services, including integrations such as the WhatsApp Business API.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-[#1C74BB] dark:text-blue-400">
            1. Information We Collect
          </h2>
          <p className="mb-4">
            We may collect personal details like <strong className="font-medium">name, phone number, email address, company information</strong>, and technical data such as <strong className="font-medium">IP address, device information, and usage patterns</strong>.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-[#1C74BB] dark:text-blue-400">
            2. How We Use Information
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>Provide and manage our IT services</li>
            <li>Authenticate WhatsApp API accounts</li>
            <li>Communicate with you</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-[#1C74BB] dark:text-blue-400">
            3. Data Sharing & Disclosure
          </h2>
          <p className="mb-4">
            We do not sell your personal information. We may share data with:
          </p>
          <ul className="list-disc list-inside space-y-2">
            <li>Meta for WhatsApp API integration</li>
            <li>Payment gateways (if applicable)</li>
            <li>Legal and regulatory bodies (if required)</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-[#1C74BB] dark:text-blue-400">
            4. Data Retention
          </h2>
          <p>
            We retain your data only as long as necessary for legal or operational reasons.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-[#1C74BB] dark:text-blue-400">
            5. Cookies
          </h2>
          <p>
            Our site uses cookies to improve user experience and analytics.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-[#1C74BB] dark:text-blue-400">
            6. Your Rights
          </h2>
          <p>
            You can request access, modification, or deletion of your data anytime by contacting us at:
          </p>
          <a href="mailto:support@dynamicsoftlink.com" className="text-[#1C74BB] dark:text-blue-400 hover:underline">
            📧 support@dynamicsoftlink.com
          </a>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-[#1C74BB] dark:text-blue-400">
            7. Security
          </h2>
          <p>
            We implement SSL encryption and secure data storage protocols to protect your information.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-[#1C74BB] dark:text-blue-400">
            8. Changes to Policy
          </h2>
          <p>
            We may update this policy periodically. Continued use of our services implies acceptance of the latest version.
          </p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-[#1C74BB] dark:text-blue-400">
            9. Contact Us
          </h2>
          <p className="mb-2">
            If you have questions about this policy:
          </p>
          <address className="not-italic space-y-2">
            <p>
              📍 Dynamic Softlink, 402, Empire State Building, Ring Rd, near Udhna Darwaja, Maan Darwaja, Rustampura, Surat, Gujarat 395002
            </p>
            <p>
              📧 <a href="mailto:info@dynamicsoftlink.com" className="text-[#1C74BB] dark:text-blue-400 hover:underline">info@dynamicsoftlink.com</a>
            </p>
          </address>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;